import React from 'react'
import classes from '@src/styles/BusinessServices.module.css'
import waste from '@src/assets/b2b-services/waste-trash.jpg'
import recycling from '@src/assets/b2b-services/recycling.jpg'
import classNames from 'classnames'
import Link from 'next/link'

const services = [
  {
    image: waste,
    header: 'Waste & Trash Pickup Services',
    features: [
      'Bulk items, appliance & junk hauling',
      'Food waste pick up',
      'Hazardous waste',
      'Hazardous compost management',
      'Construction debris & aerosols',
    ],
    tracker: 'Waste & Trash Pickup Services',
  },
  {
    image: recycling,
    header: 'Business Recycling Services',
    features: ['Cardboard', 'Paper', 'Electronics and recycle', 'Mixed and commingling recycling'],
    params: '&task=cardboard-removal',
    tracker: 'Business Recycling Services',
  },
]

function BusinessServices() {
  const handleClick = (service: any) => {
    // eslint-disable-next-line no-console
    console.log(service)
  }

  return (
    <section className={classes.container}>
      <div className={classes.mainContent}>
        <h2 className={classes.header}>
          Commercial Trash
          <br />
          Disposal Services, Recycling,
          <br />
          Bulk Item Hauling & More
        </h2>
        <h4 className={classes.subHeader}>
          Dimension is equipped to handle anything,
          <br />
          including jobs your local municipality won’t take.
        </h4>
        <p className={classes.description}>
          Whether you have one business location or one hundred, our wide range of waste solutions,
          environmental compliance expertise and business efficiencies will help us find the perfect
          solution for your business.
        </p>
        <div className={classes.boxContainer} suppressHydrationWarning>
          {services.map((service) => (
            <div key={service.header} className={classes.box}>
              <img className={classes.boxImage} src={service.image.src} alt={service.header} />
              <div className={classes.boxContent}>
                <h4 className={classNames(classes.subHeader, classes.boxHeading)}>
                  {service.header}
                </h4>
                <ul className={classes.boxList}>
                  {service.features.map((feature) => (
                    <li key={feature}>{feature}</li>
                  ))}
                </ul>
              </div>
              <Link
                href={`/booking?business_client=1${service.params ? service.params : ''}`}
                className={classes.primaryButton}
                onClick={() => handleClick(service)}
              >
                Schedule Your First Pick Up
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default BusinessServices
